<template>
  <div class="vld-parent d-flex" style="min-height: 30px;">
    <loading :active="isLoading" :color="'#ff0090'" :loader="'bars'" :is-full-page="false"></loading>
    <div v-if="!isLoading && hasSavedCreditCard" class="card w-100 my-auto mx-auto">
      <div class="card-body d-flex justify-content-between ">
        <div class="flex-column my-auto">
          <div class="d-flex my-auto">
            <fa class="h5 text-secondary my-auto mr-1" :icon="brandIcon.icon"></fa>
            <div class="text-secondary my-auto">**** {{ savedCreditCard.last4 }}</div>
          </div>
          <div class="d-flex justify-content-end">
            <p class="text-muted small my-auto">exp {{ savedCreditCard.expMonth }}/{{ savedCreditCard.expYear }}</p>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button type="button" class="btn btn-outline-primary my-auto" @click="update">Update</button>
        </div>
      </div>
    </div>
    <div v-if="!isLoading && !hasSavedCreditCard">
      <div class="text-secondary mb-2">No card on file.</div>
      <button type="button" class="btn btn-primary" @click="update">Add Credit/Debit Card</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userId: String,
    businessId: String,
    userBusinessPlanId: String,
  },
  data() {
    return {
      isLoading: true,
      savedCreditCard: null,
      brandIcons: [
        {
          brand: "Visa",
          icon: ["fab", "cc-visa"],
        },
        {
          brand: "MasterCard",
          icon: ["fab", "cc-mastercard"],
        },
        {
          brand: "American Express",
          icon: ["fab", "cc-amex"],
        },
        {
          brand: "amex",
          icon: ["fab", "cc-amex"],
        },
        {
          brand: "Diners Club",
          icon: ["fab", "cc-diners-club"],
        },
        {
          brand: "Discover",
          icon: ["fab", "cc-discover"],
        },
        {
          brand: "JCB",
          icon: "['fab', 'cc-jcb']",
        },
        {
          brand: "UnionPay",
          icon: ["fas", "credit-card"],
        },
        {
          brand: "Unknown",
          icon: ["fas", "credit-card"],
        },
      ],
    };
  },
  computed: {
    hasSavedCreditCard() {
      return !!this.savedCreditCard && !!this.savedCreditCard.last4;
    },
    brandIcon() {
      if (this.savedCreditCard.brand) {
        return this.brandIcons.find((element) => element.brand === this.savedCreditCard.brand);
      } else return { brand: "Unknown", icon: "['fas', 'credit-card']" };
    },
  },
  mounted() {
    this.reload();
  },
  methods: {
    update() {
      this.$emit("updateRequested");
    },
    reload() {
      let url;

      //business CC
      if (this.businessId && !this.userId && !this.userBusinessPlanId) url = `/businesses/${this.businessId}/creditcard`;
      //business user card
      else if (this.businessId && this.userId && this.userBusinessPlanId) url = `/businesses/${this.businessId}/members/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;
      //user cards
      else if (this.userId && !this.businessId && !this.userBusinessPlanId) url = `/users/${this.userId}/creditcard`;
      else if (this.userId && this.userBusinessPlanId && !this.businessId) url = `/users/${this.userId}/plans/${this.userBusinessPlanId}/creditcard`;

      this.$axios
        .get(url)
        .then((res) => {
          this.savedCreditCard = res.data;
          this.isLoading = false;
          this.$emit("loaded", res.data);
        })
        .catch((err) => {
          // todo: handle
          this.isLoading = false;
          console.log(err);
          debugger;
        });
    },
  },
};
</script>
